// components/ActivityTracker.js

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { getScrollDepth, getSessionId, getUserAgent, getDateKey } from "../services/analytics";

const ActivityTracker = ({ children }) => {
  const location = useLocation();
  
    

  useEffect(() => {
    const controller = new AbortController();
        let startTime = performance.now(); 
    const logActivity = async () => {
      const pageUrl = window.location.href;
      const pageTitle = document.title;
      const dateKey = getDateKey(pageUrl);

      // Prevent duplicate logs per day
      if (localStorage.getItem(dateKey)) return;

      const payload = {
        page_url: pageUrl,
        page_title: pageTitle,
        http_method: "GET",
        http_status: 200,
        scroll_depth: getScrollDepth(),
        time_on_page: Math.round(performance.now() / 1000),
        user_agent: getUserAgent(),
        session_id: getSessionId(),
        interactions: 1, // increment on clicks if needed
      };

      try {
        await axios.post("/site/lea", payload,  { signal: controller.signal });
        localStorage.setItem(dateKey, "logged");
      } catch (error) {
        //console.error("Failed to log site activity:", error);
      }
    };

    // Trigger when route changes
    logActivity();
  
    // Cleanup function to cancel the ongoing request and reset start time
    return () => {
        controller.abort();
        startTime = performance.now(); // Reset for the next route change
      };
    }, [location]); // Re-run effect when the route changes
  
    return children;
  };

export default ActivityTracker;
